import { ReferenceArea } from 'recharts';

import { CorridorParameterMargins } from '@data';

export type CorridorDataPoint = CorridorParameterMargins & {
    name: string;
    frame: number;
};

type RenderCorridorsParams = {
    corridorDataPoints?: Record<string, CorridorDataPoint[]>;
    colorMap: Record<string, string>;
    filteredDataKeys?: string[];
    displaySymbol: string;
};

export function renderCorridors({
    corridorDataPoints,
    colorMap,
    filteredDataKeys,
    displaySymbol,
}: RenderCorridorsParams) {
    if (!corridorDataPoints) return null;
    return Object.entries(corridorDataPoints).flatMap(([key, corridors], index) => {
        const barWidth = 4;
        const offset = 3 * index;
        if (filteredDataKeys?.includes(key) || !corridors.length) return [];
        return corridors.map((c) => (
            <ReferenceArea
                key={`${key}-${c.frame}`}
                yAxisId={displaySymbol}
                x1={c.frame - offset}
                x2={c.frame - offset + barWidth}
                y1={c.innerMin}
                y2={c.innerMax}
                fill={colorMap[key]}
                opacity={0.5}
            />
        ));
    });
}
